import type { Object3D } from 'three'

/**
 * 导入拓扑代理统一标记字段。
 *
 * 设计说明：
 * 1. 导入件点线面代理都是真实 Feature 对象，但它们不能进入第一阶段全场景射线；
 * 2. 该字段只在 cad-core 导入选择链路内使用，避免业务侧到处散落字符串 key；
 * 3. 第一阶段始终从 visible mesh 定位 body，第二阶段再由 BRep 权威拓扑解析点线面。
 */
export const IMPORTED_TOPOLOGY_PROXY_FLAG = 'isImportedModelTopologyProxy'

/**
 * 将导入拓扑代理标记为视觉/二阶段拾取对象。
 *
 * @param object 需要标记的拓扑代理对象。
 */
export function markImportedTopologyProxy(object: Object3D): void {
  object.userData = {
    ...object.userData,
    skipSelection: true,
    [IMPORTED_TOPOLOGY_PROXY_FLAG]: true,
  }
  /**
   * 按需创建的 FeatureLine/FeatureFace/FeaturePoint 不能参与 THREE.Raycaster 的第一阶段命中，
   * 否则大装配体会在每次 hover 时重复遍历 pick host 下的临时代理。
   */
  object.raycast = () => undefined
}

/**
 * 判断对象是否为导入拓扑代理。
 *
 * @param object 待判断对象。
 * @returns 是否为导入拓扑代理。
 */
export function isImportedTopologyProxy(object: Object3D | null | undefined): boolean {
  return object?.userData?.[IMPORTED_TOPOLOGY_PROXY_FLAG] === true
}
